import React from 'react';
// import Markdown from 'markdown-to-jsx';
import { Link } from 'react-router-dom';

import { AppContext } from '../../contexts/app-context';
// import ReleaseNotes from '../../../../RELEASENOTES.md';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import mailgo from 'mailgo';
export default class About extends React.Component {

  componentDidMount() {
    mailgo();
  }

  render() {

    return (
      <div style={{ marginTop: '-15px' }}>
        <AppContext.Consumer>
          {() => (
            <div>
              {/* <Markdown>{ReleaseNotes}</Markdown> */}
              <Typography variant='h6'>About</Typography>
              <Link to="/">
                <img src="assets/img/1-edgeway_logo_rgb.png" alt="" style={{ width: 150, height: 56 }} />
              </Link>
              <Typography variant='h6'>EdgeWay Management Portal</Typography>
              <Typography variant='subtitle2'>{this.props.version || '0.20.0'}</Typography>
              <Box marginY={2}>
                <Typography>Edgeway Vision, B.V.</Typography>
              </Box>
              <Typography>Hullenbergweg 413 1st floor,</Typography>
              <Typography>1101 SC Amsterdam,</Typography>
              <Typography>Netherlands</Typography>
              <Box mt={2} mb={3}>
                <Typography>© 2021</Typography>
                <Typography>Virtual camera technology patent pending</Typography>
              </Box>
              <Typography>Edgeway customer support</Typography>
              <a
                href="mailto:support@edgeway.io"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'grey', textDecoration: 'underline' }}
              >
                support@edgeway.io
              </a>
            </div>
          )}
        </AppContext.Consumer>
      </div>
    )
  }
}
